<div class="container-fluid content-profile bg-white" [formGroup]="userForm" autocomplete="off">
  <div class="row py-3">    
    <div class="col-1 cursor" (click)="onBackClick()">
      <div class="input-group flex-nowrap">
        <div class="input-group-prepend">
          <i class="fas fa-chevron-circle-left font-size-16" style="color: #1d2124;"></i>
        </div>
      </div>
    </div>
    <div class="col text-center">
      <h4>Edit Profile</h4>
    </div>
  </div>
  <div class="row form-group">
    <div class="col-1"></div>
    <div class="col text-center profil-image">
      <div class="container">
        <img [src]="userImageURL" alt="profile pic" class="image user-image rounded-circle img-fluid image" />
        <div class="middle">
          <label for="file">
            <i class="fas fa-user-edit fa-lg cursor p-1"></i>
            <input type="file" (change)="onSelectFile($event)" id="file" style="display: none" name="image"
              accept="image/gif,image/jpeg,image/jpg,image/png" multiple="" data-original-title="upload photo">
          </label>
        </div>
      </div>
      <span class="text-danger text-center" *ngIf="errorMessage">{{errorMessage}}</span>
      <span class="text-success text-center" *ngIf="successMessage">{{successMessage}}</span>
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label for="" class="font-weight-bold">First name</label>
      <input autocomplete="off" maxlength="50" type="text" class="form-control" placeholder="first name" formControlName="firstname"
        [ngClass]="{'has-error': ((userForm.get('firstname').touched || userForm.get('firstname').dirty) &&  userForm.get('firstname').errors)}" />
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label for="" class="font-weight-bold">Last name</label>
      <input maxlength="50" type="text" class="form-control" placeholder="last name" formControlName="lastname"
        [ngClass]="{'has-error': ((userForm.get('lastname').touched || userForm.get('lastname').dirty) &&  userForm.get('lastname').errors)}" />
    </div>
  </div>
  <div class="row pb-1">
    <div class="col">
      <span class="font-weight-bold">Mobile number</span>      
    </div>
  </div>
  <div class="row form-group">
    <div class="col">       
      <ngx-intl-tel-input [cssClass]="'form-control cursor-not-allowed'" [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
        [selectedCountryISO]="selectedCountryISO" [maxLength]="15"
        [phoneValidation]="true" [separateDialCode]="separateDialCode" name="profilemobile" formControlName="mobile"
        [ngClass]="{'has-error': ((userForm.get('mobile').touched || userForm.get('mobile').dirty) &&  userForm.get('mobile').errors)}">
      </ngx-intl-tel-input>
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label for="" class="font-weight-bold">Email address</label>
      <input type="text" class="form-control" placeholder="mail@mail.com" formControlName="email"
        [ngClass]="{'has-error': ((userForm.get('email').touched || userForm.get('email').dirty) &&  userForm.get('email').errors)}" />
    </div>
  </div>
  <div class="row">
    <div class="col">
      <button type="button" class="btn btn-outline-secondary btn-block bg-dark text-white"
        (click)="onSaveClick()">Save</button>
    </div>
  </div>
</div>
